import React from 'react';
import TsLogo from './TsLogo.jsx';

class TsHeader extends React.Component {
	render () {
		return (
			<div>
				<TsLogo />
				<h2 
					className="proxima txt-center ptm pbl mbl">
					Statistiques Trello pour Neo-nomade
				</h2>
			</div>
		);
	}
}

export default TsHeader;


// WEBPACK FOOTER //
// ./src/js/TsHeader.jsx